import { Navigate, Route, Routes } from 'react-router-dom';

import ConfirmEmail from '@/scenes/Account/components/ConfirmEmail';
import { CreateAccount } from '@/scenes/Account/components/CreateAccount';
import CreateBlog from '@/scenes/Account/components/CreateBlog';
import NotFound from '@/scenes/Dybr/Static/NotFound';
import Footer from '@/scenes/Footer/Footer';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { selectIsSignupIncomplete } from '@/store/user/selectors/selectIsSignupIncomplete';
import { useSelector } from 'react-redux';
import ResetPassword from './components/ResetPassword';

export function AccountScene() {
  const [token] = useTokenState();
  const loggedIn = Boolean(token);
  const isSignupIncomplete = useSelector(selectIsSignupIncomplete);

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/account/new" replace />} />
        <Route path="new" element={<CreateAccount />} />

        {isSignupIncomplete && (
          <Route path="confirm-email" element={<ConfirmEmail />} />
        )}
        {loggedIn && <Route path="create" element={<CreateBlog />} />}
        <Route path="reset-password" element={<ResetPassword />} />
        <Route
          path="*"
          element={<NotFound reason={'Аккаунт: что-то пошло не так'} />}
        />
      </Routes>
      <Footer withLemur />
    </>
  );
}
